import { LoadingComponent } from "../loading/LoadingPage"
import { AuthLoader } from "./AuthLoader"

export const SignUpPage = () => {
    return (
        <AuthLoader extraQueryParamenters={{ signup: "true" }}>
            <LoadingComponent />
        </AuthLoader>
    )
}